import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { isFinite, toNumber } from 'lodash';

@Directive({
  selector: 'input[numbersOnly]',
})
export class NumbersOnlyDirective {
  @Input() public allowNull = false;
  @Input() public min?: number;
  @Input() public max?: number;

  constructor(private elRef: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  public onInput(value: string) {
    const num = this.parseInput(value, false);
    const str = String(num ?? '');

    this.elRef.nativeElement.value = str;
  }

  @HostListener('blur', ['$event.target.value'])
  public onBlur(value: string) {
    const num = this.parseInput(value, true);
    const str = String(num ?? '');

    this.elRef.nativeElement.value = str;
  }

  private parseInput(str: string, checkMinMax: boolean): number | undefined {
    if (str) {
      const num = toNumber(str);
      if (isFinite(num)) {
        return checkMinMax ? this.toMinMax(num) : num;
      }
    }
    return this.allowNull ? void 0 : this.min || 0;
  }

  private toMinMax(value: number) {
    return Math.max(Math.min(value, this.max || Number.MAX_SAFE_INTEGER), this.min || 0);
  }
}
